import { lazy } from 'react';
import MainLayout from 'Layouts/Main/Main';

const WorkingCalendar = lazy(() => import('Containers/WorkingCalendar/WorkingCalendar'));

const routes = [
  {
    path: '/working-calendar',
    exact: true,
    ContentComponent: WorkingCalendar,
    Layout: MainLayout,
    name: 'Working Calendar',
  },
];

export default routes;
